import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import "./About.css";
import { Link } from "react-router-dom";


const About = () => {
  const { t } = useTranslation();

  return (
    <section className="about-section">
      <div className="about-container">
        <motion.div
          className="about-text"
          initial={{ opacity: 0, x: -60 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2>{t("About.Title")}</h2>
          <p dangerouslySetInnerHTML={{ __html: t("About.Description") }} />
          <Link to="/about" className="cta-button">
            {t("About.Button")}
          </Link>
        </motion.div>

        <motion.div
          className="about-visual"
          initial={{ opacity: 0, x: 60 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <img
            src={require("../images/aboutimage2.png")}
            alt={t("About.AltText")}
            className="about-image"
          />
        </motion.div>
      </div>
    </section>
  );
};

export default About;
